const AdminEmptyStateRow = ({ colSpan, message }) => (
  <tr>
    <td
      colSpan={colSpan}
      className="px-4 py-10 text-center text-sm text-gray-400"
    >
      {message}
    </td>
  </tr>
);

export default AdminEmptyStateRow;
